import { useSelector } from 'react-redux';

import { useExperimentSearchParams, useExperimentsTranslations } from 'modules/experiments/hooks';
import { getExperimentTimeFilterMetadata } from 'modules/experiments/ducks/selectors';
import { getFormattedDateWithHoursAndMins } from 'modules/experiments/utils';
import { TimeInfo } from './Styled';

export const ExperimentInfo = () => {
  const { t } = useExperimentsTranslations();
  const { timezone } = useExperimentSearchParams();
  const { variationCount, experimentStartDate } = useSelector(getExperimentTimeFilterMetadata);

  return (
    <>
      <span>{t('timeFilter.variantCount', { count: variationCount })}</span>
      <TimeInfo>
        {experimentStartDate
          ? t('timeFilter.launched', {
              launchDate: getFormattedDateWithHoursAndMins(experimentStartDate, timezone),
            })
          : t('timeFilter.not_launched')}
      </TimeInfo>
    </>
  );
};
